import { AspectRatios } from './layout';

export interface Caption {
  text: string;
  startTime: number;
  endTime: number;
  words: Word[];
  emoji: string;
  soundEffectUrl?: string;
  soundEffectVolume?: number | null;
  showCaption: boolean;
  shouldEmphasize?: boolean;
  positionY?: number | null;
  fontSize?: number | null;
}

export interface Broll {
  text: string;
  startTime: number;
  endTime: number;
  brollUrl?: string;
  brollType?: BrollType;
  gifUrl?: string;
  thumbnailUrl: string;
  isValid?: boolean;
  brollTransition?: string;
  keyword: string;
  brollEffect?: string;
  imageEffect?: string;
  transitionEffect?: string;
  soundEffectUrl?: string;
  soundEffectVolume?: number | null;
  brollOverlay?: BrollOverlay;
  brollLayout?: BrollLayout;
  mainPositionX?: number; // X-position for main video in split layouts
  mainPositionY?: number; // Y-position for main video in split layouts
}

export interface BrollOverlay {
  type: BrollOverlayType;
  url: string;
  positionX: number; // X-position for the b-roll element (in percentage)
  positionY: number; // Y-position for the b-roll element (in percentage)
  shadow: boolean;
  size: number;
}

export interface Word {
  word: string;
  startTime: number;
  endTime: number;
  lineBreak?: boolean;
  highlightColorId?: string | null;
}

export type BackgroundMusicData = {
  isBackgroundMusic: boolean;
  backgroundMusicVolume: number;
  backgroundMusicFile?: string;
  loopIn?: boolean;
  musicName?: string;
  isValid?: boolean;
};

export interface LogoBranding {
  type: BrandingType;
  text: string;
  logoUrl: string;
  sizeInPx: number;
  positionX: number;
  positionY: number;
  opacity: number;
}

export interface AIHookTitle {
  text: string;
  positionY: number;
  fontSize: number;
  durationInSec: number;
  fontColor: string;
  backgroundColor?: string;
}

export interface VideoMetadata {
  id: string;
  duration: number;
  width: number;
  height: number;
  fps: number;
  nb_frames: number;
}

export interface VideoTheme {
  fontStyle: FontStyle;
  captionStyle: CaptionStyle;
  layout: {
    aspectRatio: AspectRatios;
    videoPosition: {
      x: number;
      y: number;
    };
  };
}

export interface FontStyle {
  fontFamily: string;
  fontWeight: number;
  fontColor: string;
  fontSize: number;
  uppercase: boolean;
  textShadow: TextShadow;
  stroke: Stroke;
  strokeColor: string;
}

export interface CaptionStyle {
  maxWordsPerLine: number;
  positionY: number;
  hasAnimation: boolean;
  showPunctuation: boolean;
  autoEmoji: string;
  emojiAnimation: boolean;
  highlightColor1: string;
  highlightColor2: string;
  highlightColor3: string;
  punctuation: boolean;
  captionStyleId: string;
  enableFitText: boolean;
}

export enum RenderStatus {
  Draft = 'InDraft',
  InProgress = 'InProgress',
  Error = 'Error',
  Completed = 'Completed',
}

export enum PreProcessingStatus {
  InProgress = 'InProgress',
  Error = 'Error',
  Completed = 'Completed',
}

export enum BrandingType {
  Image = 'image',
  Text = 'text',
}

export enum BrollType {
  Video = 'video',
  Image = 'image',
}

export enum BrollLayout {
  Cover = 'cover',
  Contain = 'contain',
  Split5050 = 'split-50-50',
  Split6535 = 'split-65-35',
}

export enum BrollOverlayType {
  Gif = 'gif',
  Image = 'image',
  Video = 'video',
}

export enum TextShadow {
  None = 'none',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum Stroke {
  None = 'none',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum BrollEffects {
  NoAnimation = 'none',
  ZoomIn = 'zoom-in',
  ZoomOut = 'zoom-out',
  ZoomFast = 'zoom-fast',
  ZoomSlow = 'zoom-slow',
  Comic = 'comic',
  FilmBurn = 'film-burn',
  FilmBurn2 = 'film-burn-2',
  FilmBroll = 'film-broll',
  Vintage = 'vintage',
  Glitch = 'glitch',
}

export enum CaptionStyleId {
  Horimozi1 = '8dbda0f3-06cd-4936-beb1-9ab28ac15314',
  Tracy = '8dbda0f3-06cd-4936-beb1-9ab28ac15315',
  Ali = '8dbda0f3-06cd-4936-beb1-9ab28ac15316',
  Beast = '8dbda0f3-06cd-4936-beb1-9ab28ac15317',
}

export type BrollCaptionRendererProps = {
  src: string;
  videoMetadata: VideoMetadata;
  captions: Caption[];
  brolls: Broll[];
  theme: VideoTheme;
  isRender: boolean;
  // // aiHookTitle?: AIHookTitle;
  // selectedCaptionId: string;
  // branding?: LogoBranding;
  backgroundMusicData: BackgroundMusicData;
  shouldShowWatermark: boolean;
  cdnBaseUrlPath: string;
};

export interface CurrentEffect {
  activeBroll: Broll | undefined;
  selectedEffect: {
    id: BrollEffects;
    icon: string;
    label: string;
    blendStyle: string;
    type: string;
  };
  transform: string;
  isVideo: boolean;
  videoPath: string;
}
